import _isEqual from 'lodash/isEqual';

const ReRenderPropCheck = {
  pure: true,
  areOwnPropsEqual: (prev, next) => {
    const result = _isEqual(prev, next);

    return result;
  },
  areStatePropsEqual: (prev, next) => {
    const result = _isEqual(prev, next);

    return result;
  },
  areMergedPropsEqual: (prev, next) => {
    const result = _isEqual(prev, next);

    return result;
  },
};

export default ReRenderPropCheck;
